import type { UseCase } from '@/core/shared'
import type { UserRepository } from '@/core/user'

export const updateUserImage: UseCase<UserRepository, 'updateUserImage'> = repository => {
  return async (imageUpdate) => {
    await repository.updateUserImage(imageUpdate)
  }
}
